__turbopack_context__.v({
  "deleteButton": "chatHistoryList-module-scss-module__zWNfbG__deleteButton",
  "empty": "chatHistoryList-module-scss-module__zWNfbG__empty",
  "item": "chatHistoryList-module-scss-module__zWNfbG__item",
  "itemActive": "chatHistoryList-module-scss-module__zWNfbG__itemActive",
  "itemTitle": "chatHistoryList-module-scss-module__zWNfbG__itemTitle",
  "itemTitleLabel": "chatHistoryList-module-scss-module__zWNfbG__itemTitleLabel",
  "list": "chatHistoryList-module-scss-module__zWNfbG__list",
  "loadMore": "chatHistoryList-module-scss-module__zWNfbG__loadMore",
  "scroller": "chatHistoryList-module-scss-module__zWNfbG__scroller",
});
